import { observable, action } from 'mobx';
export class ensureSubmit{

  confirmEvent = null;
  cancelEvent = null;
  setConfirmEvent = (fun) => {
    this.confirmEvent = fun;
  }

  setCancelEvent = (fun) => {
    this.cancelEvent = fun;
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/ensureSubmit.js